var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbles(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 4.766a.766.766 0 10-1.531 0 .766.766 0 001.53 0zm2.914.613a3.065 3.065 0 100 6.13 3.065 3.065 0 003.065-3.064v-.001a3.065 3.065 0 00-3.065-3.065zm-3.528 5.976a1.148 1.148 0 00-2.296 0v.002a1.148 1.148 0 102.296 0v-.002zM3.138 6.759c.628 0 1.138.51 1.138 1.138v.022A1.138 1.138 0 012 7.92v-.022c0-.629.51-1.138 1.138-1.138zm10.74-1.38a1.532 1.532 0 110 3.065 1.532 1.532 0 010-3.065zm-5.395 8.414a1.517 1.517 0 10-3.035 0v.03a1.517 1.517 0 103.035 0v-.03zm2.62-2.207c.838 0 1.518.68 1.518 1.518v.03a1.517 1.517 0 11-3.035 0v-.03c0-.838.68-1.518 1.518-1.518zM18 8.896a.759.759 0 10-1.517 0v.016a.759.759 0 101.517 0v-.016zm-4.123.621a1.532 1.532 0 110 3.065 1.532 1.532 0 010-3.065z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default ForwardRef;